<template>
  <div class="mt-4">
    <div class="form-group d-flex flex-column">
      <span class="label">Upload Company Model (Excel)</span>
      <FileUpload
        action="?"
        :accept="['application/vnd.ms-excel' ,'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', '.xls', '.xlsx']"
        :auto-upload="false"
        :on-change="onFileUpload"
        class="el-upload-100"
      />
    </div>
    <div class="w-100 mt-4 py-4 d-flex border-top">
      <button
        class="ml-auto btn btn-primary "
        @click="uploadModel"
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import {errorNotification, successNotification} from '@/notifications'
import Date from '@/directives/date'
import {FileUpload} from '@frontend/components/src/FileUpload'

export default {
  components: {
    FileUpload,
  },

  directives: {
    Date,
  },
  props: {
    company: {
      required: true,
      type: Object,
    },
  },

  data () {
    return {
      models: [],
      files: [],
      upload: null,
    }
  },

  async mounted () {
    const response = await this.$http.get(`/companies/${this.company.id}/models`)

    this.models = response.data.data
  },

  methods: {
    onFileUpload (fileList) {
      const file = fileList[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        this.upload = {
          file: e.target.result,
          filename: file.name,
        }
        this.files = [{
          name: file.name,
        }]
      }

      reader.readAsDataURL(file)
    },

    async uploadModel () {
      if (!this.upload) {
        return this.$notify(errorNotification('Please select a file first'))
      }

      const {data} = await this.$http.post(`/companies/${this.company.id}/models`, this.upload)

      if (data) {
        this.$notify(successNotification('Model has been updated'))
        this.models.push(data.data)
      }
    },

    async downloadModel (model) {
      const {data} = await this.$http.get(`/company-models/${model.id}`)

      location.href = data.data.link
    },
  },
}
</script>
